import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export const ServicesAccordion = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const services = [{
    title: 'Washing Machines',
    description: 'Complete diagnostics and repairs for all washing machine faults—drum issues, leaks, drainage problems and more.'
  }, {
    title: 'Dishwashers',
    description: "Expert repairs for dishwashers that won't drain, clean properly, or complete cycles. We fix pump and heating element faults."
  }, {
    title: 'Tumble Dryers',
    description: "Repairs for dryers that won't heat, stop mid-cycle, or make unusual noises. We handle all major brands."
  }, {
    title: 'Cookers & Ovens',
    description: 'Safe repairs for electric cookers and ovens—faulty heating elements, broken doors, and control panel issues.'
  }, {
    title: 'Fridges & Freezers',
    description: "Fast response for fridges and freezers that won't cool, frost up, or leak. We diagnose thermostat and compressor faults."
  }, {
    title: 'TVs & Set-Top Boxes',
    description: 'Repairs for TV connection issues, screen faults, and set-top box problems. Quick turnaround for most issues.'
  }];
  return <div className="bg-slate-50 py-16" data-id="element-184">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-185">
        <h2 className="text-3xl font-bold text-slate-800 text-center mb-12" data-id="element-186">
          Appliances We Repair
        </h2>
        <div className="space-y-4" data-id="element-187">
          {services.map((service, index) => <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden border-l-4 border-blue-500" data-id="element-188">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between hover:bg-slate-50 transition-colors" data-id="element-189">
                <span className="text-lg font-semibold text-slate-800" data-id="element-190">
                  {service.title}
                </span>
                <ChevronDown className={`w-5 h-5 text-slate-600 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-191" />
              </button>
              {openIndex === index && <div className="px-6 pb-4" data-id="element-192">
                  <p className="text-slate-600" data-id="element-193">{service.description}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </div>;
};